import {
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSImage,
  WSMessageBox,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import {
  useInvoicesQuery,
  useInvoiceTemplatesQuery
} from "../../../query/payments/queries";
import { WSQueries } from "../../../query/WSQuery";
import smile from "../../../assets/images/party-smile.png";

type Props = WSElementProps;

export const FirstInvoiceBanner: React.FC<Props> = ({ ...elementProps }) => {
  const invoicesQuery = useInvoicesQuery();
  const invoiceTemplatesQuery = useInvoiceTemplatesQuery();

  return (
    <WSElement {...elementProps}>
      <WSQueries queries={{ invoicesQuery, invoiceTemplatesQuery }}>
        {({
          invoicesQuery: { data: invoices },
          invoiceTemplatesQuery: { data: invoiceTemplates }
        }) =>
          invoices.length + invoiceTemplates.length === 1 && (
            <WSMessageBox noBorder>
              <WSFlexBox.Center>
                <WSImage src={smile} placeholder={<></>} width={16} />
                <WSText ml="S">You just sent your first invoice!!</WSText>
              </WSFlexBox.Center>
            </WSMessageBox>
          )
        }
      </WSQueries>
    </WSElement>
  );
};
